export default __webpack_public_path__ + "50fe9d108bf37168aa322d093a337e03.png";